export default "__VITE_ASSET__CuAT4I$u__"